module.exports = __webpack_public_path__ + "static/img/14.129fb7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/zh/14.png
// module id = AJkg
// module chunks = 0